import { render, staticRenderFns } from "./PSSC.vue?vue&type=template&id=6a21be78&lang=pug"
import script from "./PSSC.vue?vue&type=script&lang=js"
export * from "./PSSC.vue?vue&type=script&lang=js"
import style0 from "./PSSC.vue?vue&type=style&index=0&id=6a21be78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports